import global from "global";

export default () => global.location.href;
